import { CommonService } from './../Services/common.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { SettingService } from '../Services/setting.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: "app-settings-update-mobile-number",
  templateUrl: "./settings-update-mobile-number.component.html",
  standalone:false,
  styleUrls: ["./settings-update-mobile-number.component.scss"],
})
export class SettingsUpdateMobileNumberComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  otp: string = "";
  MobileCode: string = "+973";
  MobileNo: string = "";
  oldMob: string = "";
  Email: string = "";
  EnableForChange: boolean = true;
  oldMob2: string;

  constructor(
    private location: Location,
    private _router: Router,
    public auth: AuthService,
    public CommonService: CommonService,private cookieService:CookieService,
    private setting: SettingService
  ) {}

  async ngOnInit(): Promise<void> {
    this.auth.accessToken = await this.CommonService.Get("token");
    await this.CommonService.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            await this.CommonService.hideLoading();
            this.MobileNo = this.auth?.detailuser?.mobileNumber;
            this.oldMob = this.auth?.detailuser?.mobileNumber;
             this.oldMob2 = data?.response?.content?.mobileNumber;
            console.log("MobileNo", this.MobileNo);
            this.Email = this.auth?.detailuser?.emailId;
          } else {
            await this.CommonService.hideLoading();

            this.CommonService.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.CommonService.hideLoading();

          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  back() {
    this.location.back();
  }

  onOtpChange(e) {
    if (e.length == 4) {
      this.otp = e.toString();
    } else {
      this.otp = null;
    }
  }

  onKeyDownSaveChanges(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      this.updateMobile(2);
    }
  }
  // onKeyDownEmail(event: KeyboardEvent): void {
  //   if (event.key === "Enter") {
  //     this.verifyViaEmailOtp(3);
  //   }
  // }
  // onKeyDownMobile(event: KeyboardEvent): void {
  //   if (event.key === "Enter") {
  //     this.verifyViaMobileOtp();
  //   }
  // }
  updateMobile(num) {
    let body = {
      MobileNumber: this.MobileCode + this.MobileNo,
    };

    this.CommonService.presentLoading();
    this.setting.SendChangeMobileEmailOTP(this.auth.accessToken, body)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.CommonService.hideLoading();
          // this.showModal(num);
              //  this.cookieService.set("UpdatedMob", JSON.stringify(this.MobileCode + this.MobileNo), false,undefined,undefined,undefined,undefined,true,"Strict");
            this.cookieService.set("upM32B", JSON.stringify(this.MobileNo),true);      
          this._router.navigateByUrl("/VerifyEmailOtp");

        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

 

 
  // Change(event) {
  //   
  //   // if(event.srcElement.value!==''){
  //   if (this.oldMob2 == this.MobileNo || this.MobileNo == "") {
  //     
  //     this.EnableForChange = true;
  //   } else {
  //     
  //     this.EnableForChange = false;
  //   }
  // }
//   EnableForChange: boolean = true; // initially disabled
// oldMob2: string = "551815104"; // your old number
// MobileNo: string = "";

isSameNumber: boolean = false;

onMobileChange(value: string) {
  this.MobileNo = value;

  if (this.MobileNo.length === 8) {
    if (this.MobileNo === this.oldMob2) {
      this.EnableForChange = true;
      this.isSameNumber = true;
    } else {
      this.EnableForChange = false;
      this.isSameNumber = false;
    }
  } else {
    this.EnableForChange = true;
    this.isSameNumber = false;
  }
}
// onMobileChange(value: string) {
//   this.MobileNo = value;

//   // Check only when 8 digits are entered
//   if (this.MobileNo.length === 8) {
//     if (this.MobileNo === this.oldMob2) {
//       this.EnableForChange = true; // Disable button
//     } else {
//       this.EnableForChange = false; // Enable button
//     }
//   } else {
//     // While number is incomplete, keep button disabled
//     this.EnableForChange = true;
//   }
// }

  // verifyMobileOtp() {
  //   this._router.navigateByUrl("/VerifyMobileOtp");
  // }
}
